import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching enabled flag values failed' }))
  .then(parseAsJson);

export const fetchCompanyCodes = async ({ periodName }) => await fetch(
  Config.endpoints.FETCH_ENABLED_COMPANY_CODES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching company codes failed' }))
  .then(parseAsJson);

export const fetchTBECompanyCodes = async ({ periodName, companyCode, tbeLegalEntity }) => await fetch(
  Config.endpoints.FETCH_ENABLED_TBE_COMPANY_CODES
    .replace(/:periodName/, periodName)
    .replace(/:companyCode/, companyCode)
    .replace(/:tbeLegalEntity/, tbeLegalEntity)
)
  .then(handleErrors({ errorMessage: 'Fetching TBE company codes failed' }))
  .then(parseAsJson);

export const fetchImportStatus = async () => await fetch(
  Config.endpoints.FETCH_IMPORT_STATUS_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching import status failed' }))
  .then(parseAsJson);

export const fetchUsTaxTypes = async () => await fetch(Config.endpoints.FETCH_US_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching US tax types failed' }))
  .then(parseAsJson);

export const fetchLocalTaxTypes = async () => await fetch(Config.endpoints.FETCH_LOCAL_TAX_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching local tax types failed' }))
  .then(parseAsJson);

export const fetchTBEtypes = async () => await fetch(Config.endpoints.FETCH_TAX_BOOKING_ENTITY_TYPES)
  .then(handleErrors({ errorMessage: 'Fetching TBE types failed' }))
  .then(parseAsJson);
